import { createTheme } from '@mantine/core';

// Carson Capital Management Brand Colors
const primaryBlue = [
  '#e6eef5',
  '#c2d6e8',
  '#9dbeda',
  '#78a7cd',
  '#538fc0',
  '#2e77b3',
  '#052f5f',
  '#04274e',
  '#041f3d',
  '#03172d',
] as const;

const secondaryBlueGreen = [
  '#e6f2f5',
  '#c2dfe8',
  '#9dcbda',
  '#78b8cd',
  '#53a5c0',
  '#2e92b3',
  '#005377',
  '#00435f',
  '#003347',
  '#00222f',
] as const;

const accentOrange = [
  '#fef4e6',
  '#fde6c2',
  '#fcd89d',
  '#fbca78',
  '#fabc53',
  '#f9ae2e',
  '#e49908',
  '#b67a06',
  '#885b05',
  '#5a3d04',
] as const;

const accentMellowYellow = [
  '#faf8ed',
  '#f2efd0',
  '#eae5b3',
  '#e2dc96',
  '#dad279',
  '#d2c95c',
  '#d5c67a',
  '#aa9e62',
  '#807749',
  '#554f31',
] as const;

const accentGreen = [
  '#e6f7f3',
  '#c2ebe2',
  '#9ddfd1',
  '#78d3c0',
  '#53c7af',
  '#2ebb9e',
  '#06a77d',
  '#058664',
  '#04654b',
  '#034332',
] as const;

const accentRed = [
  '#f7e9e6',
  '#ebc9c2',
  '#dfa99d',
  '#d38978',
  '#c76953',
  '#bb492e',
  '#a73006',
  '#862605',
  '#651d04',
  '#431303',
] as const;

export const theme = createTheme({
  colors: {
    'primary-blue': primaryBlue,
    'secondary-blue-green': secondaryBlueGreen,
    'accent-orange': accentOrange,
    'accent-mellow-yellow': accentMellowYellow,
    'accent-green': accentGreen,
    'accent-red': accentRed,
  },
  primaryColor: 'accent-orange',
});
